module.exports = __webpack_public_path__ + "img/digitalIdentity13.54a45058.png";